import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pending",
  "use": "icon-pending-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pending\">\n<g id=\"icon-pending_&#229;&#156;&#134;-&#230;&#156;&#170;&#233;&#128;&#137;&#228;&#184;&#173;\">\n<g id=\"icon-pending_Ellipse 9\">\n<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"white\" />\n<circle cx=\"10\" cy=\"10\" r=\"9.5\" stroke=\"#001529\" stroke-opacity=\"0.3\" />\n</g>\n<circle id=\"icon-pending_Ellipse 10\" cx=\"10\" cy=\"10\" r=\"4\" fill=\"#001529\" fill-opacity=\"0.3\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol